import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import User from './views/User';
import Home from './views/home';
import Scan from './views/scan';
import UserDetails from './views/UserDetails';
import SideBar from './components/SideBar';
import Login from './views/login';
import ScanResult from './views/scanResult';
import ScanDetails from './views/scanDetails';
import ProtectedRoute from './routes/ProtectedRoute';
import DeepAnalysis from './views/deepanalysis/deepanalysis';
import Analysis from './views/deepanalysis/analysis';

const AppRoutes = () => {
  const location = useLocation();
  const isLoginRoute = location.pathname === '/';
  const isScanResultRoute = location.pathname === '/scan_results';

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Login />} />
      <Route path="/scan_results" element={<ScanResult />} />

      {/* Deep Analysis routes - no sidebar, wrapped with DataProvider */}
      <Route
        path="/deep-analysis"
        element={
          <ProtectedRoute>
            <Analysis />
          </ProtectedRoute>
        }
      />
      <Route
        path="/deep-analysis/:id/:id"
        element={
            <ProtectedRoute>
              <DeepAnalysis />
            </ProtectedRoute>
        }
      />

      {/* Other private routes inside Sidebar */}
      {!isLoginRoute && !isScanResultRoute && (
        <Route
          path="*"
          element={
            <SideBar>
              <Routes>
                <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                <Route path="/users" element={<ProtectedRoute><User /></ProtectedRoute>} />
                <Route path="/users/:id" element={<ProtectedRoute><UserDetails /></ProtectedRoute>} />
                <Route path="/scans" element={<ProtectedRoute><Scan /></ProtectedRoute>} />
                <Route path="/users/:id/:scan_id" element={<ProtectedRoute><ScanDetails /></ProtectedRoute>} />
                <Route path="*" element={<>Not Found</>} />
              </Routes>
            </SideBar>
          }
        />
      )}
    </Routes>
  );
};

const App = () => (
  <Router>
    <ToastContainer />
    <AppRoutes />
  </Router>
);

export default App;
